<template>
  <b-card
    no-body
  >
    <!-- title and dropdown -->
    <b-card-header class="pb-0">
      <b-card-title>تیکت ها</b-card-title>
      <b-dropdown
        no-caret
        right
        :text="duration"
        variant="transparent"
        class="chart-dropdown"
        toggle-class="p-50"
        size="sm"
      >
        <b-dropdown-item
          v-for="(day,index) in enums('durations')"
          :key="index"
          @click="changeDuration(day)"
        >
          {{ day.text }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>
    <!--/ title and dropdown -->

    <b-card-body>
      <b-overlay
        :show="loading"
        rounded="sm"
      >
        <b-row>
          <b-col
            sm="2"
            class="d-flex flex-column flex-wrap text-center"
          >
            <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
              {{ totalCount }}
            </h1>
            <small>مجموع</small>
          </b-col>
          <!-- chart -->
          <b-col
            sm="10"
            class="d-flex justify-content-center"
          >
            <!-- apex chart -->
            <vue-apex-charts
              v-if="showReport"
              type="radialBar"
              height="270"
              :options="supportTrackerRadialBar.chartOptions"
              :series="series"
            />
          </b-col>
          <!--/ chart -->
        </b-row>

        <!-- chart info -->
        <div class="d-flex justify-content-between mt-5">
          <div
            v-for="report in statisticsItems"
            class="text-center"
          >
            <b-card-text class="mb-50">
              {{ report.title }}
            </b-card-text>
            <span class="font-large-1 font-weight-bold">{{ report.value }}</span>
          </div>
        </div>
        <div
          class="mt-1 c-scroll"
          style="overflow-y: auto;height:100px"
        >
          <div
            v-for="admin in admins"
            class="text-center mr-2"
          >
            <b-card-text class="mb-50">
              {{ admin.title }}
            </b-card-text>
            <span class="font-large-1 font-weight-bold">{{ admin.value }}</span>
          </div>
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BRow, BCol, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  name: 'TicketReport',
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
  },
  props: {

  },
  data() {
    return {
      loading: false,
      showReport: true,
      series: [],
      duration: '7 روز اخیر',
      totalCount: null,
      supportTrackerRadialBar: {
        chartOptions: {
          chart: {
            fontFamily: 'IranSans',
          },
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '65%',
              },
              track: {
                background: '#fff',
                strokeWidth: '100%',
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: '#5e5873',
                  fontSize: '1rem',
                },
                value: {
                  offsetY: 15,
                  color: '#5e5873',
                  fontSize: '1.714rem',
                },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: ['تیکت های بسته شده'],
        },
      },
      statisticsItems: [
        {
          title: 'جدید',
          value: '',
          onServer: 'New',
        },
        {
          title: 'در حال برسی',
          value: '',
          onServer: 'InProgress',
        },
        {
          title: 'پاسخ ادمین',
          value: '',
          onServer: 'AdminReply',
        },
        {
          title: 'پاسخ کاربر',
          value: '',
          onServer: 'UserReply',
        },
        {
          title: 'بسته',
          value: '',
          onServer: 'Closed',
        },
      ],
      admins: [],
    }
  },
  created() {
    this.setReports(7)
  },
  methods: {
    changeDuration(e) {
      this.duration = e.text
      this.setReports(e.value)
    },
    setReports(val) {
      this.loading = true
      this.admins = []
      this.series = []
      this.$http.post(this.$api.report.ticketReports, {
        Day: val,
      }).then(response => {
        this.statisticsItems.forEach(item => {
          item.value = response.data[item.onServer]
        })
        this.totalCount = response.data.TotalCount
        const closedPercent = this.totalCount > 0 ? Math.round((response.data.Closed / this.totalCount) * 100) : 0;
        this.series = [closedPercent];
        (response.data.User || []).forEach(user => {
          this.admins.push({
            title: user.Family,
            image: user.Image,
            value: user.Count,
          })
        })
        this.showReport = true
      }).finally(() => this.loading = false)
    },
  },
}
</script>
<style>
.c-scroll>div{
  display: inline-block;
}
</style>
